import { Connection } from '@solana/web3.js';
import { RpcEndpoint } from '@velocity-exchange/common';
import Env from 'src/environmentVariables/EnvironmentVariables';

export const generateConnection = (rpc: RpcEndpoint) => {
	if (process.env.NEXT_PUBLIC_RPC_OVERRIDE) {
		return new Connection(process.env.NEXT_PUBLIC_RPC_OVERRIDE, {
			commitment: Env.defaultCommitmentLevel,
			wsEndpoint: process.env.NEXT_PUBLIC_RPC_WS_OVERRIDE,
		});
	}

	return new Connection(rpc.value, {
		commitment: Env.defaultCommitmentLevel,
		wsEndpoint: rpc?.wsValue,
	});
};
